var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.meta.hideNavigation)?_c('div',{attrs:{"id":"main"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fof"},[_c('h1',[_vm._v("404 not found")])])
}]

export { render, staticRenderFns }